const pharmacy = `Hello, I've been having a persistent headache for the past couple of days,
and I was wondering if you could recommend any medication to help alleviate the pain.
It's been quite bothersome, and I would appreciate any assistance you could provide.
Thank you.`;
export default pharmacy;